import React from "react";

import { showProcess, hideProcess, UserSession, getFileServer } from "../utils/util";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import saleOrderService from "../services/saleOrderService";

function withParams(Component) {
    return (props) => <PaymentConclude {...props} params={useParams()} />;
}

class PaymentConclude extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            const response = await saleOrderService.getById(this.props.params.id);

            console.dir(UserSession);

            if (response.status === 200) {
                if (response.data === null || response.data === undefined || response.data === "") {
                    window.location.href = "/";
                }

                this.setState({ saleOrder: response.data });
            } else {
                alert("ERRO AO CARREGAR PAGINA");
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    render() {
        if (
            this.state.saleOrder !== undefined &&
            this.state.saleOrder !== null &&
            this.state.saleOrder !== ""
        )
            return (
                <div
                    style={{
                        backgroundColor: "#ffffff",
                        padding: window.innerWidth < 768 ? "15px" : "40px",
                        overflowX: "hidden",
                    }}
                >
                    {/* Título */}
                    <label
                        style={{
                            fontFamily: "var(--unnamed-font-family-helvetica-neue)",
                            fontSize: window.innerWidth < 768 ? "26px" : "44px",
                            color: "#411172",
                            fontWeight: "bold",
                            display: "block",
                            textAlign: window.innerWidth < 768 ? "center" : "left",
                            lineHeight: "1.3",
                        }}
                    >
                        Obrigado pela sua compra, {UserSession.name}.
                    </label>

                    <div style={{ marginTop: window.innerWidth < 768 ? "15px" : "25px" }} />

                    {/* Texto de agradecimento */}
                    <label
                        style={{
                            fontFamily: "var(--unnamed-font-family-helvetica-neue)",
                            fontSize: window.innerWidth < 768 ? "16px" : "21px",
                            color: "#411172",
                            display: "block",
                            textAlign: window.innerWidth < 768 ? "center" : "left",
                        }}
                    >
                        Obrigado por comprar conosco. Estamos processando a sua compra e avisaremos
                        assim que estiver pronto.
                    </label>
                    <label
                        style={{
                            fontFamily: "var(--unnamed-font-family-helvetica-neue)",
                            fontSize: window.innerWidth < 768 ? "16px" : "21px",
                            color: "#411172",
                            display: "block",
                            textAlign: window.innerWidth < 768 ? "center" : "left",
                            marginTop: "5px",
                        }}
                    >
                        Você vai receber as atualizações do seu pedido no email {UserSession.email}.
                    </label>

                    {/* Tabela resumo */}
                    <div style={{ marginTop: window.innerWidth < 768 ? "30px" : "50px" }}>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                textAlign: "center",
                            }}
                        >
                            <tbody>
                                <tr>
                                    <td>
                                        <label
                                            style={{
                                                color: "#411172",
                                                fontSize: window.innerWidth < 768 ? "16px" : "22px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Pedido#
                                        </label>
                                    </td>
                                    <td>
                                        <label
                                            style={{
                                                color: "#411172",
                                                fontSize: window.innerWidth < 768 ? "16px" : "22px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Valor do Pedido
                                        </label>
                                    </td>
                                    <td>
                                        <label
                                            style={{
                                                color: "#411172",
                                                fontSize: window.innerWidth < 768 ? "16px" : "22px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Ítens do Pedido
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label
                                            style={{
                                                color: "#411172",
                                                fontSize: window.innerWidth < 768 ? "16px" : "22px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {this.state.saleOrder.id}
                                        </label>
                                    </td>
                                    <td>
                                        <label
                                            style={{
                                                color: "#411172",
                                                fontSize: window.innerWidth < 768 ? "16px" : "22px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            R$
                                            {this.state.saleOrder.amount.toLocaleString("pt-BR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </label>
                                    </td>
                                    <td>
                                        <label
                                            style={{
                                                color: "#411172",
                                                fontSize: window.innerWidth < 768 ? "16px" : "22px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {this.state.saleOrder.lines.length}
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Lista de produtos */}
                    <div style={{ backgroundColor: "#ffffff", marginTop: "40px" }}>
                        {this.state.saleOrder.lines.map((l, i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    flexDirection: window.innerWidth < 768 ? "column" : "row",
                                    alignItems: window.innerWidth < 768 ? "center" : "flex-start",
                                    borderBottom: "1px solid #ddd",
                                    padding: window.innerWidth < 768 ? "15px 0" : "20px",
                                }}
                            >
                                <img
                                    src={`${this.state.fileServer}/cards/${l.product.id}.png`}
                                    alt={l.product.displayName}
                                    style={{
                                        width: window.innerWidth < 768 ? "90%" : "360px",
                                        height: window.innerWidth < 768 ? "auto" : "237px",
                                        borderRadius: "8px",
                                    }}
                                />

                                <div
                                    style={{
                                        paddingLeft: window.innerWidth < 768 ? "0" : "25px",
                                        marginTop: window.innerWidth < 768 ? "15px" : "0",
                                        textAlign: window.innerWidth < 768 ? "center" : "left",
                                    }}
                                >
                                    <span
                                        style={{
                                            fontFamily: "var(--unnamed-font-family-helvetica-neue)",
                                            fontSize: window.innerWidth < 768 ? "18px" : "21px",
                                            color: "#411172",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {l.product.displayName}
                                    </span>
                                    <div style={{ marginTop: "10px" }} />
                                    <span
                                        style={{
                                            fontFamily: "var(--unnamed-font-family-helvetica-neue)",
                                            fontSize: window.innerWidth < 768 ? "16px" : "21px",
                                            color: "#411172",
                                        }}
                                    >
                                        R$
                                        {l.product.amount.toLocaleString("pt-BR", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </span>
                                    <div style={{ marginTop: "10px" }} />
                                    <span
                                        style={{
                                            fontFamily: "var(--unnamed-font-family-helvetica-neue)",
                                            fontSize: window.innerWidth < 768 ? "16px" : "21px",
                                            color: "#411172",
                                            display: "block",
                                            lineHeight: "1.4",
                                        }}
                                    >
                                        Seu gift-card será enviado para {UserSession.name} no e-mail{" "}
                                        {UserSession.email}.
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
    }
}

export default withParams(PaymentConclude);
